"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineCounts = void 0;
const runtypes_1 = require("runtypes");
exports.LineCounts = (0, runtypes_1.Record)({
    source: runtypes_1.Number,
    comment: runtypes_1.Number,
    blank: runtypes_1.Number,
});
//# sourceMappingURL=linecounts.js.map